import { useMutation } from '@apollo/client'
import { Questionnaire, QuestionnaireVariables } from '../../types'
import { QUESTIONNAIRE } from './operations'

export const useSendQuestionnaireResult = () =>
  useMutation<Questionnaire, QuestionnaireVariables>(QUESTIONNAIRE)
